module.exports = __webpack_public_path__ + "static/media/book.1f8dc4c5.jpg";